import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "domain" }
const _hoisted_3 = { class: "notice-container" }
const _hoisted_4 = { class: "notice-title pc" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "notice-title h5" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "notice-content" }
const _hoisted_9 = { class: "notice-content-title" }
const _hoisted_10 = ["innerHTML"]

import {ref} from 'vue';
import { getNoticeList, postNoticeInfo } from "@/api";
import {useRouter} from "vue-router";

export default /*@__PURE__*/_defineComponent({
  __name: 'NoticeView',
  setup(__props) {

const router = useRouter();

const noticeList = ref<any>([]);
const noticeId = ref<number>(0);
const noticeTitle = ref<string>('');
const noticeContent = ref<string>('');
const timeID = setInterval(() => {
    if (sessionStorage.getItem('domain')) {
        getNotice();
        clearTimeout(timeID)
    }
},200)
// fetch('/notice.json').then((response) => response.json())
//     .then((json) => {
//         noticeList.value = json.noticeArr;
//     })
// 获取公告列表
const getNotice = async  () => {
    const params = {
        page: 1,
        pageSize: 20
    }
    const result =  await getNoticeList(params);
    if (result.data?.data) {
        const data = result.data?.data;
        noticeList.value = noticeList.value.concat(data.noticeInfoList);
        noticeList.value.sort((a:any,b: any) => {
            return b.id - a.id;
        })
        noticeId.value = noticeList.value[0].id;
        if (noticeId.value && noticeId.value > 0) {
            await selectNoticeInfo();
        } else {
            for (let i = 0; i < noticeList.value.length; i++) {
                const el = noticeList.value[i];
                if (el.id === noticeId.value) {
                    noticeTitle.value = el.title;
                    noticeContent.value = el.content;
                }
            }

        }

    }
}

const selectNotice = (id: number,str: string) => {
    if (noticeId.value === id) return;
    if (str === 'h5') {
        router.push({
            name: 'NoticeInfo',
            params: {
                id
            }
        });
    } else {
        noticeId.value  = id;
        if (noticeId.value && noticeId.value > 0) {
            selectNoticeInfo();
        } else {
            for (let i = 0; i < noticeList.value.length; i++) {
                const el = noticeList.value[i];
                if (el.id === noticeId.value) {
                    noticeTitle.value = el.title;
                    noticeContent.value = el.content;
                }
            }

        }
    }
}
// 获取公告详情
const selectNoticeInfo = async  () => {
    const params = {
        id: noticeId.value
    }
    const result =  await postNoticeInfo(params);

    if (result.data?.data) {
        const data = result.data?.data.noticeInfo;
        noticeTitle.value = data.title;
        noticeContent.value = data.content;

    }
}




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", null, _toDisplayString(_ctx.$t('最新公告')), 1),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(noticeList.value, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              onClick: ($event: any) => (selectNotice(item.id,'pc')),
              class: _normalizeClass([{'native' : noticeId.value == item.id}, "notice-title-text"]),
              key: item.id
            }, _toDisplayString(item.title), 11, _hoisted_5))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(noticeList.value, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              onClick: ($event: any) => (selectNotice(item.id, 'h5')),
              class: _normalizeClass([{'native' : noticeId.value == item.id}, "notice-title-text"]),
              key: item.id
            }, _toDisplayString(item.title), 11, _hoisted_7))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, _toDisplayString(noticeTitle.value), 1),
          _createElementVNode("div", {
            innerHTML: noticeContent.value,
            class: "notice-info"
          }, null, 8, _hoisted_10)
        ])
      ])
    ])
  ]))
}
}

})